import { Alert } from '../../components/common'
import useZoneContainer from './useZone'

interface ZoneContainer {
  children?: React.ReactNode
}
const ZoneContainer = (props: ZoneContainer) => {
  const { children } = props

  const { error } = useZoneContainer()

  return (
    <>
      {error && (
        <>
          <Alert title="Unable to load zone" jsonData={error} />
        </>
      )}
      {children}
    </>
  )
}

export default ZoneContainer
